import {usePortalsStore} from '@/Store/portals/portals.selector';
import {useCallback} from 'react';

const useCloseCampaign = () => {
  const {setIsShowCampaignPortal} = usePortalsStore().actions;
  return useCallback(() => setIsShowCampaignPortal(false), []);
};
export default useCloseCampaign;
